import React, { useEffect, useState } from 'react'
import './image-container.styles.scss';
import { getDownloadURL, getStorage, ref } from 'firebase/storage';

const ImageContainer = ({ src, alt, className, onClick, keyId, id, title, grayscale, circle }) => {

    const [ imageSrc, setImageSrc ] = useState(null);
    const storage = getStorage();

    useEffect(() => {
        if (!src) return;
        async function setImageData() {
            if (src.includes('https://') || src.includes('blob:')) {
                setImageSrc(src);
            } else if (src.includes('storage:')) {
                let url = await getDownloadUrlFromPath(src.replace('storage:', ''))
                setImageSrc(url);
            } else {
                setImageSrc(import.meta.env.VITE_ROOT + src)
            }
        }
        setImageData();
    }, [src])

    async function getDownloadUrlFromPath(path) {
        getDownloadURL(ref(storage, path))
        .then( url => {
            // This can be downloaded directly:
            const xhr = new XMLHttpRequest();
            xhr.responseType = 'blob';
            xhr.onload = (event) => {
                const blob = xhr.response;
                const urlFromBlob = URL.createObjectURL(blob);
                setImageSrc(urlFromBlob);
            };
            xhr.open('GET', url);
            xhr.send();
        });
        // return urlFromPath;
    }
    return (
        <div className='image-container-div'>
            {
            (imageSrc) &&
            <img 
                id={id ?? null}
                key={keyId}
                src={imageSrc}
                className={`container-image ${className ?? ''}${grayscale ? ' grayscale' : ''}${circle ? ' circle' : ''}`} 
                alt={alt ?? 'decorative image'} 
                referrerPolicy='no-referrer'
                loading='lazy'
                onClick={onClick} 
                title={title ?? null}
                // onMouseDown={e => {alert('Image cannot be copied'); return false}}
            />
            }
        </div>
    )
}

export default ImageContainer